module.exports = __webpack_public_path__ + "img/160.fb495223.jpg";